const styles = theme => ({
  noOrganizationPageContainer: {
    height: "100vh"
  },
  title: {
    color: theme.palette.primary.default
  },
  subtitle: {
    color: theme.palette.primary.default,
    marginBottom: theme.spacing(3)
  },
  joinButton: {
    marginRight: theme.spacing(2)
  }
})
export default styles



// WEBPACK FOOTER //
// ./src/pages/NoOrganizationPage/styles.js